import React from 'react';
import styled from '@emotion/styled';
import DashedLine from '../icons/dashed-line.svg';
import { AlertMessage } from '../../AlertMessage/component';
import Lock from '../icons/lock.svg';
import UserCheck from '../icons/user-check.svg';
import User from '../icons/user.svg';
import { OL_COLOUR_BLACK_90 } from '../../Style/colours';
import { BREAKPOINT_MOBILE } from '../../Style/breakpoints';
import { ROUTE_SSO } from '../../../../ReduxStorage/routeActions';
import { HELP_ORIGIN } from '../../../../constants';
import { RouteLink } from '../../RouteLink/component';

const ContentWrapper = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: 60,
  marginBottom: 60,
  padding: 0,
  alignItems: 'center',
});

const MessageWrapper = styled('div')({
  lineHeight: '26px',
});

const LogoWrapper = styled('div')({
  img: {
    width: 130,
    height: 130,
  },
  div: {
    marginTop: 10,
    fontWeight: 600,
    fontSize: 14,
    color: OL_COLOUR_BLACK_90,
  },
  textAlign: 'center',
  margin: '0 10px',
  [`@media (max-width: ${BREAKPOINT_MOBILE})`]: {
    img: {
      width: 50,
      height: 50,
    },
  },
});

const DashedLineImg = styled('img')({
  width: 150,
  position: 'relative',
  bottom: 12,
  [`@media (max-width: ${BREAKPOINT_MOBILE})`]: {
    width: 30,
    bottom: 28,
  },
});
export const AllowCameraConfirmation: React.FC = () => {
  return (
    <>
      <AlertMessage
        kind="info"
        message={
          <MessageWrapper>
            <p>
              As a requirement for this course, OpenLearning needs to verify
              your facial identity. This is done by capturing a short video of
              your face. Your data is safely stored and ensures the academic
              integrity of your coursework.
            </p>
            <RouteLink
              to={{
                type: ROUTE_SSO,
                params: {
                  action: 'help',
                },
                query: {
                  url: `${HELP_ORIGIN}/t/35hl6l3`,
                },
              }}
              target="_blank"
            >
              Learn more about identity verification on OpenLearning
            </RouteLink>
          </MessageWrapper>
        }
      />
      <ContentWrapper>
        <LogoWrapper>
          <img src={User} alt="user-capture" />
          <div>Video face capture</div>
        </LogoWrapper>
        <DashedLineImg src={DashedLine} alt="dashed-line" />
        <LogoWrapper>
          <img src={Lock} alt="lock" />
          <div>Safe data storage</div>
        </LogoWrapper>
        <DashedLineImg src={DashedLine} alt="dashed-line" />
        <LogoWrapper>
          <img src={UserCheck} alt="user-check" />
          <div>Facial identity verified</div>
        </LogoWrapper>
      </ContentWrapper>
    </>
  );
};
